import { categoryTypes } from '../types';
import type { Expense, Tag } from '../types';

function escapeCsvField(value: string): string {
  if (/[";\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export const EXPENSE_CSV_HEADER = [
  'Data',
  'Título',
  'Descrição',
  'Categoria',
  'Tags',
  'Valor',
];

export function buildExpenseCsvRows(
  expenses: Expense[],
  availableTags: Tag[]
): string[][] {
  return expenses.map((expense) => {
    const tags = availableTags
      .filter((tag) => expense.tags?.includes(tag.id))
      .map((tag) => tag.name)
      .join(', ');

    return [
      new Date(expense.date).toLocaleDateString('pt-BR'),
      expense.title,
      expense.description ?? '',
      categoryTypes[expense.categoryType]?.label ?? expense.categoryType,
      tags,
      expense.value.toFixed(2).replace('.', ','),
    ];
  });
}

export function downloadCsv(
  header: string[],
  rows: string[][],
  filename: string
) {
  const csvContent = [header, ...rows]
    .map((row) => row.map((field) => escapeCsvField(String(field))).join(';'))
    .join('\n');
  const blob = new Blob(['﻿' + csvContent], {
    type: 'text/csv;charset=utf-8;',
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportExpensesToCsv(
  expenses: Expense[],
  availableTags: Tag[],
  filename = 'gastos.csv'
) {
  downloadCsv(
    EXPENSE_CSV_HEADER,
    buildExpenseCsvRows(expenses, availableTags),
    filename
  );
}
